import { defineRule, configure, form, field } from 'vee-validate';
import { required, email, min, max, numeric } from '@vee-validate/rules';

defineRule('regex', (value, [pattern]) => {
  if (!value) return true; // Allow empty values if not required
  const regex = new RegExp(pattern);
  return regex.test(value) || 'Ogiltigt format';
});

// Register Rules
defineRule('required', required);
defineRule('email', email);
defineRule('min', min);
defineRule('max', max);
defineRule('numeric', numeric);


// Swedish SSN validation rule
defineRule('swedishSSN', (input) => {
  if (input.indexOf('-') === -1) {
    if (input.length === 10) {
      return false;
      //  input = input.slice(0, 6) + "-" + input.slice(6);
    } else {
      input = input.slice(0, 8) + "-" + input.slice(8);
    }
  }

  if (!input.match(/^(\d{2})(\d{2})(\d{2})\-(\d{4})|(\d{4})(\d{2})(\d{2})\-(\d{4})$/)) {
    return false
  };

  return true;

});

defineRule('swedishSSNWrong', (input) => {
  if (input.indexOf('-') === -1) {
    if (input.length === 10) {
      return false;
      //  input = input.slice(0, 6) + "-" + input.slice(6);
    } else {
      input = input.slice(0, 8) + "-" + input.slice(8);
    }
  }

  if (!input.match(/^(\d{2})(\d{2})(\d{2})\-(\d{4})|(\d{4})(\d{2})(\d{2})\-(\d{4})$/)) {
    return false
  };

  // Clean input
  input = input.replace('-', '');
  if (input.length === 12) {
    input = input.substring(2);
  }

  //RegExp.$7 om den är mer än 31 är 60 pålagt, om det är det ta bort 60 och jämför med den istället. Gör en parseInt för kontroll.
  var regInt = parseInt(RegExp.$7);
  if (regInt > 60 && regInt < 91) {
    regInt = regInt - 60;

    // Declare variables
    var d = new Date(((!!RegExp.$1) ? RegExp.$1 : RegExp.$5), (((!!RegExp.$2) ? RegExp.$2 : RegExp.$6) - 1), ((!!RegExp.$3) ? RegExp.$3 : regInt.toString())),
      sum = 0,
      numdigits = input.length,
      parity = numdigits % 2,
      i,
      digit;
  } else {
    // Declare variables
    var d = new Date(((!!RegExp.$1) ? RegExp.$1 : RegExp.$5), (((!!RegExp.$2) ? RegExp.$2 : RegExp.$6) - 1), ((!!RegExp.$3) ? RegExp.$3 : RegExp.$7)),
      sum = 0,
      numdigits = input.length,
      parity = numdigits % 2,
      i,
      digit;
  }


  // Check valid date
  if (Object.prototype.toString.call(d) !== "[object Date]" || isNaN(d.getTime())) return false;

  // Check luhn algorithm
  for (i = 0; i < numdigits; i = i + 1) {
    digit = parseInt(input.charAt(i), 10);
    if (i % 2 === parity) {
      digit *= 2;
    }
    if (digit > 9) {
      digit -= 9;
    }
    sum += digit;
  }
  return (sum % 10) === 0;

});

// Zip Code validation rule
defineRule('zipCode', (value) => {
  if (!value || value.length !== 5) {
    return 'Postnumret måste vara fem siffror'
  }
  return /^[0-9]{5}$/.test(value) ? true : 'Ogiltigt postnummer';
});

defineRule('confirmed', (value, [target], ctx) => {
  if (value === ctx.form[target]) {
    return true
  }
  return 'Fälten matchar inte'
})

defineRule('alpha_spaces_numbers', (value) => {
  if (!value) return true;
  let regex = /@/i;
  if (regex.test(value)) {
    return 'Ogiltigt format'; // ge felmeddelande om @ finns
  }

  return /[A-Za-zÅÄÖåäö]/.test(value)
    ? true
    : 'Ogiltigt format';

});


// New password rule
defineRule('newPassword', (value, oldPassword) => {
  return value !== oldPassword ? true : 'Det nya lösenordet måste vara unikt';
});


configure({
  generateMessage: ({ field, rule }) => {
    const messages = {
      required: `Fältet är obligatoriskt`,
      email: 'Ange en giltig e-postadress',
      min: `Fältet måste innehålla minst ${rule.params[0]} tecken`,
      max: `Du kan endast använda ${rule.params[0]} tecken i fältet`,
      numeric: `Fältet får endast innehålla siffror`,
      swedishSSN: `Formatet måste vara ÅÅÅÅMMDDNNNN`,
      swedishSSNWrong: `Felaktigt personnummer`,
    };
    return messages[rule.name] || `Ogiltigt värde för ${field}`;
  },
  validateOnBlur: true,
  validateOnChange: true,
});

export default {
  install(app) {
  }
};

